const lang = {
    gzjq:'市場假期',
    xgsc:'香港',
    xgscs:'香港',
    mgsc:'美國',
    mgscs:'美國',
    china:'中國',
    chinas:'中國',
    xjp:'新加坡',
    xjps:'新加坡',
    ja:'日本',
    az:'澳洲',
    tw:'台灣',
    d_g:'德股',
    dg:'德國',
    ml:'馬來西亞',
    china_c:'中國',
    xjp_c:'新加坡',
    ja_c:'日本',
    az_c:'澳洲',
    tw_c:'台灣',
    ml_c:'馬來西亞',
    xg:'香港',
    am:'美國',
    grzh:'個人帳戶',
    gszh:'公司帳戶',
    wtlb:'問題類別',
    sswt:'搜索問題',
    yhmc:'銀行名稱',
    zhhm:'帳戶號碼 / 貨幣種類',
    swif:'銀行代碼',
    addre:'分行地址',
    zhmc:'帳戶名稱',
    xggp:'香港證券',
    scjs:'市場介紹',
    jyfs:'交易須知',
    fwsf:'服務收費',
    jytg:'交易通告',
    jytgs:'最新通告',
    gstg:'公司通告',
    jtzb:'集團總部',
    lxwm:'聯繫我們',
    ybcx:'一般查詢',
    jyrx:'交易熱線',
    mfndzx:'免費內地專線',
    cz:'傳真',
    dy:'電郵',
    bgsj:'辦公時間',
    dtime:'上午9:00 -下午6:00 星期六、星期日及香港公眾假期休息',
    zcgl:'資產管理',
    glfw:'管理服務',
    tzcl:'投資策略',
    qmiswx:'華亞金融集團官方微信',
    homes:'首頁 / 環球股票',
    b_fimg:require('@/image/home/alld.png'),
    getimage:require('@/image/home/getimage.png'),
    hongd_img:require('@/image/honggu/downimg.png'),
    rq_date:'日期',
    rq_biaoti:'通告',
    hongd_img_model:require('@/image/home_model/downimg.png'),
    getimagemodel:require('@/image/home_model/getimage.png'),
    mzsm:'免責聲明',
    qmisyeas:'版權所有 2021 華亞金融集團保留擁有權',
    agree:'同意',
    an_ree:'不同意',
    Android:require('@/image/home/Android_cn.png'),
    Android_s:require('@/image/home_s/Android_cn.png'),
    mod_and:require('@/image/home_model/Android.png'),
    inSearch:'搜索',
    isBack:'返回上頁',
    jjfw:'基金服務',
    jjcp:'基金產品',
    mggp:'美國股票',
    xgrg:'新股認購',
    xgrl:'新股日曆',
    xjpg:'新加坡股',
    malxy:'馬來西亞股',
    aozg:'澳洲股',
    jagu:'日股',
    twstk:'台股',
    slgt:'滬深港通',
    zqfw:'債券服務',
    gpzc:'股票轉倉',
    klzh:'開立帳戶',
    tckx:'款項提存',
    qlkh:'親臨開戶',
    ydkh:'郵遞開戶',
    yykh:'預約開戶',
    zxkh:'在線開戶',
    wskh:'網上開戶',
    sjfw:'數據服務',
    zjcq:'資金存取',
    bgxz:'表格下載',
    cjwt:'常見問題',
    cn_login:'登入交易平台',
    nYeat:' 年',




    ywjj:'業務簡介',
    cpfw:'產品及服務',
    zsw:'暫時沒有結果符合您的搜索條件“',
    cxss:'”，請重新搜索。',
    ssjy:'以下是一些搜索建議',
    y1:'請檢查是否所有內容均輸入正確',
    y2:'嘗試更改常用的字詞或減少查詢字詞的數量',
    y3:'嘗試改用其他關鍵字或使用近義詞',
    alb:'按類別搜索',
    Alert:'澄清啟事',
    bew:'偽冒華亞金融集團名稱及公司商標進行違法和欺詐推銷',
    ithas:'華亞金融集團 （QMIS FINANCIAL GROUP） （「本集團」）近日得悉有騙徒偽冒本集團透過電話及 / 或即時通訊軟件（例如 WhatsApp及微信等社交媒介），訛稱本集團進行招募工作，以賺取佣金作為利誘，誘騙受害人提供個人資料及存入金錢。',
    ithas1:'本集團茲澄清，上述之違法和欺詐推廣活動，一概與本集團及本集團旗下任何附屬公司（包括但不限於華亞證券有限公司及華亞資產管理有限公司）無關。本集團謹此呼籲各位切勿在任何情況下向第三者支付任何款項及 / 或透露任何敏感的個人及/或帳戶信息，請小心保護個人資料。',
    ithas2:'如懷疑受騙或需要協助，敬請立即前往警署報案或致電香港警務處反詐騙協調中心「防騙易」熱線18222查詢。',
    ithas3:'特此澄清',
    qgp:'華亞金融集團 啟',
    dapas:'二零二二年三月十一日',
    yuedu:'已閱讀',

    zgdl: "中國",
    zgxg: "中國香港",
    zgam: "中國澳門",
    adly: "澳大利亞",
    jnd: "加拿大",
    mlxy: "馬來西亞",
    mg: "美國",
    xjp1: "新加坡",
    xxl: "新西蘭",
    yg: "英國",

    title_1:'預約開立香港證券帳戶',
    title_2:'歡迎使用預約開戶服務，本行職員會於此申請表遞交後儘快致電您以確認會面詳情。如需協助，請於辦公時間內致電客戶服務熱線 (852) 3971 6919 或親臨本行查詢。',
    title_3:'個人資料',
    zwmc_yy:'中文名稱',
    cw_yy:'稱謂',
    dydz_yy:'電郵地址',
    lldh_yy:'聯絡電話',
    
    title_4:'預約詳情',
    yyrq_yy:'預約日期',
    yysj_yy:'預約時間',
    yzm_yy:'驗證碼',
    dj_yy:'遞交',


    // 马来文

    
    ystk:'Dasar Data Privasi',
    fxpl:'Penyata Pendedahan Risiko',
    tkxz:'Terma & Syarat Penggunaan',
    clj:'Dasar Hiperpautan',
    aqts:'Petua Pengunaan Keselamatan',
    grsm:'Penyata Pengumpulan Data Peribadi',

    home:'Pengenalan',
    whatWeDo:'Tindakan Kami Lakukan',

    investment:'Perbankan Pelaburan',
    global:'Sekuriti Global',
    digital:'Kewangan Digital',
    asset:'Pengurusan Aset',
    wealth:'Pengurusan Harta',
    financial:'Pajakan Kewangan',


    newsEvents:'Berita & Peristiwa',
    aboutUs:'Perihal Kami',
    contactUs:'Hubungi Kami',
    latest:'Pengumuman Terkini',

    letUs:'Biar Kami Menghubungi Anda',
    yourInfo:'Maklumat Anda',
    FirstName:'Nama Pertama',
    LastName:'Nama Akhir',
    Email_bank:'E-mel',
    PhoneNumber:'Serah Nombor',
    Subject:'Subjek',
    Account:'Pembukaan Akaun',
    Careers:'Kerjaya',
    Others:'Lain-lain',
    Comments:'Komen atau Soalan',
    Submit_bank:'Hantar',
  
    Reminder:'Peringatan',
    Submission:'Penyerahan Selesai',


    cookies1:'Kami menggunakan kuki untuk menilai penggunaan Laman Web anda dan untuk memberikan anda pengalaman laman web yang terbaik. Dengan meneruskan melayari Laman Web ini, anda menerima penggunaan kuki kami untuk mengumpul data. Untuk butiran, sila rujuk',
    cookies2:'Dasar Data Privasi',
    cookies3:'Laman Web dan',
    cookies4:'Penyata Pengumpulan Data Peribadi',
    cookies5:'Sahkan',

    BookFlights:'Tempah Penerbangan',
    PleaseLeaveYour:'Sila tinggalkan butiran hubungan anda dan maklumat permintaan filght, kami akan menghubungi anda secepat mungkin.',
    PersonalName:'Nama Peribadi',
    CompanyName:'Nama Syarikat',
    Title:'Tajuk',
    DateofBirth:'Tarikh Lahir',
    PhoneNumber:'Nombor Telefon',
    emailAddress:'Alamat E-mel',
    LeavingFrom:'Bertolak Dari',
    GoingTo:'Pergi Ke',
    TripType:'Jenis Perjalanan',
    CabinClassandPassengers:'Kelas Kabin dan Penumpang',
    DepartingOn:'Berlepas Pada',
    ReturningOn:'Kembali Hidup',
    SelectYour:'Pilih tarikh perjalanan anda',
    Remark:'Teguran',
    PleaseEnter:'Sila Masukkan',
    PleaseChoose:'Sila Pilih',
    Mr:'Encik',
    Mrs:'Puan',
    Ms:'Cik',
    Miss:'Cik',
    Canada:'Kanada',
    USA:'Amerika Syarikat',
    Singapore:'Singapura',
    Countries:'Negara / Wilayah',
    Return:'Kembali',
    Oneway:'Sehala',
    SelectCabinClass:'Pilih kelas kabin dan bilangan penumpang',
    Class:'Kelas',
    First:'Pertama',
    Business:'Perniagaan',
    PremiumEconomy:'Ekonomi Premium',
    Economy:'Ekonomi',
    BookingofMoreThan4:'Tempahan lebih daripada 4 penumpang tidak tersedia dalam talian pada masa ini. Sila hubungi pejabat tempahan tempatan anda.',
    BookingofMoreThan9:'Tempahan lebih daripada 9 penumpang tidak tersedia dalam talian pada masa ini. Sila hubungi pejabat tempahan tempatan anda.',
    Adults:'Dewasa (12+)',
    Children:'Kanak-kanak (2 hingga 11)',
    Infants:'Bayi (bawah 2)',
    Done:'Selesai',
    MarketHoliday:'Cuti Pasaran Saham',
    Announcements:'Pengumuman',
    Date:'Tarikh',
    Holiday:'Cuti',
    Day:'Hari',
    Continue:'Diteruskan',
    Back:'Belakang',

    Mar:'Mac',
    May:'Mei',
    Aug:'Ogos',
    Oct:'Okt',
    Dec:'Dis',

    Mar1:'MAC',
    May1:'MEI',
    Aug1:'OGOS',
    Oct1:'OKT',
    Dec1:'DIS',




   
}

export default lang;



// WEBPACK FOOTER //
// ./src/assets/malay.js